// Make sure to prefix the mutation names with the module to avoid collisions
export const MANAGED_PAGE_SET_MANAGED_PAGE = 'managedPageSetManagedPage'
export const MANAGED_PAGE_SET_MANAGED_PAGES ='managedPageSetManagedPages'